import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faInstagram as fabInstagram, faTiktok as fabTiktok, faYoutube as fabYoutube, faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons';
import useFetch from './ApiClient/GetApi';

const SUB_LIMIT = 7;

export default function Header() {
  const [openIndex, setOpenIndex] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuAnimating, setMenuAnimating] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedCats, setExpandedCats] = useState(() => new Set());

  const navigate = useNavigate();
  const { apiData } = useFetch("/user/getAllCategories");
  const getPages = useFetch("/user/getPages");

  const categories = apiData?.data?.categories || [];

  const openMenu = () => {
    setMenuVisible(true);
    setTimeout(() => setMenuOpen(true), 10);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setMenuAnimating(true);
    setTimeout(() => {
      setMenuVisible(false);
      setMenuAnimating(false);
    }, 400);
  };

  const handleCategoryClick = (categoryTitle) => {
    closeMenu();
    navigate('/category', { state: { category: categoryTitle } });
  };

  const handleSubmenuItemClick = (categoryTitle, subItem, subCategoryId) => {
    closeMenu();
    navigate(`/${categoryTitle}/${subItem}`, { state: { subCategoryId } });
  };

  const isExpanded = (catId) => expandedCats.has(catId);
  const toggleExpanded = (catId) => {
    setExpandedCats(prev => {
      const next = new Set(prev);
      if (next.has(catId)) next.delete(catId);
      else next.add(catId);
      return next;
    });
  };

  // 🔹 Search filter (category + subcategory)
  const filteredCategories = categories.filter(cat => {
    if (!searchQuery) return true;
    const q = searchQuery.toLowerCase();
    const inCategory = cat.name.toLowerCase().includes(q);
    const inSub = (cat.subCategories || []).some(sub =>
      sub.name.toLowerCase().includes(q)
    );
    return inCategory || inSub;
  });

  return (
    <header>
      <Link to="/">
        <img className="logo" src="/logo.png" alt="Logo" />
      </Link>

      <button className="menu-btn" onClick={openMenu}>
        <span className="menu-text">MENU</span>
        <img className="menu-img" src="/menus.png" alt="Menu" />
      </button>

      {menuVisible && (
        <aside className={`overlay-menu${menuOpen ? ' menu-enter' : menuAnimating ? ' menu-exit' : ''}`}>
          {/* 🔹 SEARCH BAR ONLY FILTERS CATEGORIES */}
          <div className="search-row">
            <input
              className="search-bar"
              placeholder="SEARCH CATEGORY"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="close-btn" onClick={closeMenu} aria-label="Close">×</button>
          </div>

          <ul className="categories">
            {filteredCategories.length > 0 ? (
              filteredCategories.map((category, index) => {
                const subs = category.subCategories || [];
                const showAll = isExpanded(category.id);
                const visibleSubs = showAll ? subs : subs.slice(0, SUB_LIMIT);
                const hasMore = subs.length > SUB_LIMIT;

                return (
                  <li key={category.id} style={{ padding: "10px 0px" }}>
                    <div className="category-main spaced">
                      <span
                        className="category-title clickable"
                        onClick={() => handleCategoryClick(category.name)}
                      >
                        {category.name}
                      </span>
                      <span
                        className="dropdown dropdown-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenIndex(openIndex === index ? null : index);
                        }}
                        aria-label="Toggle submenu"
                      >
                        <FontAwesomeIcon icon={openIndex === index ? faChevronUp : faChevronDown} />
                      </span>
                    </div>

                    {openIndex === index && (
                      <div className={"submenu below submenu--open"}>
                        {visibleSubs.map((sub) => (
                          <span
                            key={sub.id}
                            className="submenu-item clickable"
                            onClick={() => handleSubmenuItemClick(category.name, sub.name, sub.id)}
                          >
                            {sub.name}
                          </span>
                        ))}
                        {hasMore && (
                          <span
                            className="submenu-item submenu-see-more clickable"
                            onClick={() => toggleExpanded(category.id)}
                            style={{ fontWeight: 600, opacity: 0.9 }}
                          >
                            {showAll ? 'See less' : `See more (+${subs.length - SUB_LIMIT})`}
                          </span>
                        )}
                      </div>
                    )}
                  </li>
                );
              })
            ) : (
              <span>No matching categories found</span>
            )}
          </ul>

          <footer className="overlay-footer">
            <div className="socials">
              <span className="icon"><FontAwesomeIcon icon={fabInstagram} /></span>
              <span className="icon"><FontAwesomeIcon icon={fabTiktok} /></span>
              <span className="icon"><FontAwesomeIcon icon={fabYoutube} /></span>
              <span className="icon"><FontAwesomeIcon icon={fabFacebook} /></span>
            </div>

            <div className="footer-links">


              {/* Dynamic Pages from API */}
              <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem", flexWrap: "wrap" }}>
                {getPages?.apiData?.data?.pages?.map((pg) => (
                  <Link key={pg.id} to={`page/${pg.slug}`} className="page-link">
                    {pg.name.toUpperCase()}
                  </Link>
                ))}
              </div>





            </div>

            <a href='/'><img className="footer-logo-img" src="/footer.png" alt="Logo" /></a>
          </footer>

        </aside>
      )}
    </header>
  );
}
